// @flow
import { Sparkle, Check } from 'lucide-react';

import { useTranslator } from '@gandi/translate';

import styles from './offers.scss';

export const Offers = (): React.MixedElement => {
  const { __ } = useTranslator();

  const features = [
    __('Filters and antispam'),
    __('Antivirus'),
    __('Compatible with Outlook, Mail, and Thunderbird'),
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Sparkle className={styles.icon} />
        <p className={styles.title}>{__('Always included')}</p>
      </div>

      <ul className={styles.featuresList}>
        {features.map(feature => (
          <li key={feature} className={styles.feature}>
            <Check size={16} className={styles.checkIcon} />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};
